import React from "react";
import { Form, InputGroup } from "react-bootstrap";

const SEARCH_TYPES = [
    {
        value: "nameModel",
        label: "نام و مدل"
    },
    {
        value: "code",
        label: "کد"
    },
    {
        value: "barcode",
        label: "بارکد"
    }
];

const ProductSearch = ({
    searchType,
    searchText,
    onSearchTypeChange,
    onSearchTextChange
}) => {

    const handleTypeChange = (event) => {
        onSearchTypeChange(event.target.value);
    };

    const handleTextChange = (event) => {
        onSearchTextChange(event.target.value);
    };

    return (
        <div className="product-search">
            <Form>
                <InputGroup className="product-search-group">

                    <Form.Control
                        as="select"
                        value={searchType}
                        onChange={handleTypeChange}
                        className="product-search-type"
                        aria-label="نوع جستجو"
                    >
                        {SEARCH_TYPES.map((item) => (
                            <option
                                key={item.value}
                                value={item.value}
                            >
                                {item.label}
                            </option>
                        ))}
                    </Form.Control>

                    <Form.Control
                        type="text"
                        value={searchText}
                        onChange={handleTextChange}
                        placeholder="جستجوی محصول..."
                        className="product-search-input"
                        autoComplete="off"
                    />

                </InputGroup>
            </Form>
        </div>
    );
};

export default ProductSearch;
